export interface MeterDisplay {
  /** Count shown inside the ring; compact from 1000 up so it still fits. */
  ringLabel: string;
  /** Line under the meter title. */
  subtext: string;
  /** At or above the plan cap. Never true on an unlimited plan. */
  atLimit: boolean;
  ariaLabel: string;
}

const COMPACT_FROM = 1000;

const formatRingLabel = (used: number): string => {
  if (used < COMPACT_FROM) return `${used}`;
  // Floored, not rounded: a ring must never show more than is actually used.
  const thousands = Math.floor(used / 100) / 10;
  return `${thousands}k`;
};

/**
 * Text and state for one usage meter (shared items or shared boards) on the
 * item view header, kept apart from the markup so the rules are testable
 * without rendering the ring.
 */
export const getMeterDisplay = (
  used: number,
  max: number | null | undefined,
  percent: number,
  unlimited: boolean,
  noun: "items" | "boards",
): MeterDisplay => {
  const ringLabel = formatRingLabel(used);

  if (unlimited) {
    return {
      ringLabel,
      subtext: `${used} shared`,
      atLimit: false,
      ariaLabel: `${used} shared ${noun}, unlimited`,
    };
  }

  const atLimit = percent >= 100;

  return {
    ringLabel,
    subtext: atLimit ? `${used} of ${max} · limit reached` : `${used} of ${max} shared`,
    atLimit,
    ariaLabel: `${used} of ${max} shared ${noun} used${atLimit ? ", limit reached" : ""}`,
  };
};
